import styles from "./Subpage.module.css";
import {
  TextEditor,
  ButtonGroup,
} from "components/molecules";
import _ from "lodash";
import React, { FC } from "react";
import { ButtonSelectionType } from "types";
import classNames from "classnames";

type TSubPageContentProps = {
  TextEditor1: string,
  ButtonSelection1: ButtonSelectionType[],
  ButtonAlignment1: any,
  DisplaySimplifiedBannerDesktop: boolean,
  DisplaySimplifiedBannerMobile: boolean,
  isDesktop?: boolean
  DisplaySideBar: boolean;
  children: React.ReactNode
}

const _SubPageContent: FC<TSubPageContentProps> = ({
  TextEditor1,
  ButtonSelection1,
  ButtonAlignment1,
  DisplaySimplifiedBannerDesktop,
  DisplaySimplifiedBannerMobile,
  isDesktop,
  DisplaySideBar,
  children
}: any) => {

  return (
    <div className={classNames(styles.content,  isDesktop ? 'col-8' : 'col-12' )}>
      {children}
      {TextEditor1 && <TextEditor
        isDesktop={isDesktop}
        DisplaySimplifiedBannerDesktop={DisplaySimplifiedBannerDesktop}
        DisplaySimplifiedBannerMobile={DisplaySimplifiedBannerMobile}
        className="TextEditor-1"
        data={TextEditor1}
      />}

      {ButtonSelection1?.length > 0 && (
        <ButtonGroup className="button-group-1" alignment={ButtonAlignment1} buttons={ButtonSelection1} />
      )}
    </div>
  );
};

export const SubPageContent = React.memo(_SubPageContent)
